export default __webpack_public_path__ + "static/media/google_play_badge_eng.f902960a.png";